"use client";
import React from "react";
import MultiGiroContext from "@/contexts/multigiro-context";
import { GIRO_PRESETS, type GiroPreset } from "@/constants/giro-presets";

export default function MultiGiroProvider({ children }: { children: React.ReactNode }) {
  const [giro, setGiro] = React.useState<GiroPreset>(GIRO_PRESETS[0]);
  const value = React.useMemo(() => ({ giro, setGiro }), [giro]);
  return <MultiGiroContext.Provider value={value}>{children}</MultiGiroContext.Provider>;
}
